function includeSet(a: Set<any>, b: Set<any>): boolean {
  return [...b].reduce((pre, cur) => {
    return pre && a.has(cur);
  }, true);
}

export default includeSet;
